import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import { MobileButton, MobileRegularPage } from '../../../components';
import useStyles from "./SignupSuccess.style";

const SignUpSuccess = () => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <MobileRegularPage>
            <Typography variant="h3" className={classes.title}>{t('signUpSuccess.title')}</Typography>
            <Typography variant="h5" className={classes.text}>
                {t('signUpSuccess.instructions')}
            </Typography>
            <Box className={classes.buttonContainer}>
                <MobileButton
                    className={classes.button}
                    label={t('signUpSuccess.buttonLabel')}
                    component={Link} to="/app/signin" />
            </Box>
        </MobileRegularPage>
    );
};

export default SignUpSuccess;